export const VALID_ACADEMY_RESOURCE_TYPES = [
  'Best practices',
  'Certificate',
  'Course',
  'Getting started',
  'Learning path',
  'Live training',
  'Quick guide',
];

export const VALID_ACADEMY_RESOURCE_LANGUAGES = [
  'English',
  'French',
  'Spanish',
];

export const TAGS_TYPE_PARTNER = 'type:Partner';
export const FILTERS_TAGS_TYPE_PARTNER = `tags:"${TAGS_TYPE_PARTNER}"`;
